import { Document, Packer, Paragraph, ImageRun, TextRun, Table, TableRow, TableCell, WidthType, BorderStyle, convertInchesToTwip, PageOrientation, VerticalAlignAttributes, VerticalAlign } from "docx";
import { saveAs } from "file-saver";
import pdfImage from "../../components/PDF/pdfImage";
import dateFormat from "dateformat";

export const wordRPT210 = (dataReport, setShowMessages, setLoading) => {
    setLoading(true);
    let filename = "RPT210_" + dateFormat(new Date(), "yyyymmdd");

    const font = {
        size: {
            p: 28,
            tbHeader: 28,
            tbbody: 28,
            normal: 28,
            num: 28,
        },
        SarabunPSK: "TH SarabunPSK",
    };

    const cellBorder = {
        noBorder: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        line: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
    };

    const chk = (key) => {
        if (dataReport.length > 0) {
            return dataReport[0][key] === "Y" ? pdfImage.checkBox : pdfImage.unchecked;
        }
    };

    const setView = (key) => {
        if (dataReport.length > 0) {
            return dataReport[0][key] === null || dataReport[0][key] === "" ? "" : dataReport[0][key];
        }
    };

    const space = new Paragraph({
        children: [],
    });

    const p1 = new Paragraph({
        alignment: "right",
        children: [
            new TextRun({
                text: "วันที่",
                size: font.size.p,
                font: font.SarabunPSK,
            }),
            new TextRun({
                text: " " + dataReport[0].reportDate,
                size: font.size.p,
                font: font.SarabunPSK,
                underline: { type: "dotted" },
            }),
        ],
    });

    const setTb1 = () => {
        const arr = [
            {
                value: chk("weekFlag"),
                width: 1,
                alignment: "right",
            },
            {
                value: " รายสัปดาห์",
                width: 1,
                alignment: "center",
            },
            {
                value: chk("monthFlag"),
                width: 1,
                alignment: "right",
            },
            {
                value: " รายเดือน",
                width: 1,
                alignment: "center",
            },
            {
                value: " ระหว่างวันที่ ",
                width: 1,
                alignment: "center",
            },
            {
                value: setView("reportDateBegin"),
                width: 1,
                alignment: "left",
            },
            {
                value: " ถึงวันที่ ",
                width: 1,
                alignment: "center",
            },
            {
                value: setView("reportDateEnd"),
                width: 1,
                alignment: "left",
            },
            {
                value: "",
                width: 10,
                alignment: "center",
            },
        ];

        return arr.map((item, index) => {
            if (index !== 0 && index !== 2) {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    margins: { top: convertInchesToTwip(0.2) },
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                });
            } else {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    margins: { top: convertInchesToTwip(0.2) },
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new ImageRun({
                                    data: item.value,
                                    transformation: {
                                        width: 15,
                                        height: 15,
                                    },
                                }),
                            ],
                        }),
                    ],
                });
            }
        });
    };

    const tb1 = new Table({
        rows: [
            new TableRow({
                children: [...setTb1()],
            }),
        ],
    });

    const setTb2 = () => {
        const arr = [
            {
                value: " เลขที่สัญญา ",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("contractNo"),
                width: 2,
                alignment: "left",
            },
            {
                value: " ผู้ควบคุมงาน ",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("supervisorName"),
                width: 2,
                alignment: "left",
            },
            {
                value: "วันเริ่มสัญญา",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("contractDateBegin"),
                width: 2,
                alignment: "left",
            },
            {
                value: "วงเงินดำเนินการ",
                width: 2,
            },
            {
                value: setView("operateAmount"),
                width: 2,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            if (index % 2 === 0) {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                });
            } else {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                    underline: { type: "dotted" },
                                }),
                            ],
                        }),
                    ],
                });
            }
        });
    };
    const tb2 = new Table({
        rows: [
            new TableRow({
                children: [...setTb2()],
            }),
        ],
    });

    const setTb3 = () => {
        const arr = [
            {
                value: "PO.",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("planNo"),
                width: 2,
                alignment: "left",
            },
            {
                value: "ผู้รับจ้าง",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("contractorName"),
                width: 2,
                alignment: "left",
            },
            {
                value: "วันสิ้นสุดสัญญา",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("contractDateEnd"),
                width: 2,
                alignment: "left",
            },
            {
                value: "วงเงินคงเหลือ",
                width: 2,
            },
            {
                value: setView("remainAmount"),
                width: 2,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            if (index % 2 === 0) {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                });
            } else {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                    underline: { type: "dotted" },
                                }),
                            ],
                        }),
                    ],
                });
            }
        });
    };
    const tb3 = new Table({
        rows: [
            new TableRow({
                children: [...setTb3()],
            }),
        ],
    });

    const setTb4 = () => {
        const arr = [
            {
                value: "AUC(ค่าแรง)",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("auc"),
                width: 2,
                alignment: "left",
            },
            {
                value: "วงเงินสัญญา",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("contractAmount"),
                width: 2,
                alignment: "left",
            },
            {
                value: "วันส่งงานเส้นทาง",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("lastDeliverDate"),
                width: 2,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            if (index % 2 === 0) {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                });
            } else {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                    underline: { type: "dotted" },
                                }),
                            ],
                        }),
                    ],
                });
            }
        });
    };
    const tb4 = new Table({
        rows: [
            new TableRow({
                children: [...setTb4()],
            }),
        ],
    });

    const setTb5 = () => {
        const arr = [
            {
                value: "วันที่ลงนาม",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("contractSignDate"),
                width: 2,
                alignment: "left",
            },
            {
                value: "อัตราค่าปรับ (บาท/วัน)",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("fineRate"),
                width: 2,
                alignment: "left",
            },
            {
                value: "ระยะเวลาตามสัญญา",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("contractPeriod"),
                width: 2,
                alignment: "left",
            },
            {
                value: "ระยะเวลาก่อสร้างจริง",
                width: 2,
                alignment: "left",
            },
            {
                value: setView("actualPeriod"),
                width: 2,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            if (index % 2 === 0) {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                });
            } else {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                    underline: { type: "dotted" },
                                }),
                            ],
                        }),
                    ],
                });
            }
        });
    };
    const tb5 = new Table({
        rows: [
            new TableRow({
                children: [...setTb5()],
            }),
        ],
    });

    const setHeadTbR1 = () => {
        const arr = [
            {
                value: "เส้นทาง",
                rowSpan: 3,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "หน่วยงานเจ้าของพื้นที่",
                rowSpan: 3,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "สถานที่",
                rowSpan: 3,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "ผิว\nจราจร",
                rowSpan: 3,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "เลขที่แบบแปลน",
                rowSpan: 3,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "ตามแบบ",
                rowSpan: 0,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "ผลงานก่อสร้าง",
                rowSpan: 0,
                colSpan: 2,
                width: 5,
                alignment: "center",
            },
            {
                value: "วันที่\nอนุมัติ\nเข้า",
                rowSpan: 3,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "ระยะ\nเวลา\n(วัน)",
                rowSpan: 3,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "วันที่ทำการก่อสร้าง",
                rowSpan: 0,
                colSpan: 4,
                width: 5,
                alignment: "center",
            },
            {
                value: "ตรวจรับงาน\nครั้งสุดท้าย\nวันที่",
                rowSpan: 3,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
        ];
        return arr.map((item) => {
            return new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                rowSpan: item.rowSpan,
                columnSpan: item.colSpan,
                width: {
                    size: convertInchesToTwip(item.width),
                    type: WidthType.DXA,
                },
                children: [
                    new Paragraph({
                        alignment: "center",
                        children: [
                            new TextRun({
                                text: item.value,
                                bold: true,
                                size: font.size.tbHeader,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };

    const setHeadTbR2 = () => {
        const arr = [
            {
                value: "ความยาวท่อ(ม.)",
                rowSpan: 2,
                colSpan: 0,
                width: 5,
                alignment: "center",
            },
            {
                value: "ความยาวท่อ(ม.)",
                rowSpan: 0,
                colSpan: 2,
                width: 5,
                alignment: "center",
            },
            {
                value: "ตามแผน",
                rowSpan: 0,
                colSpan: 2,
                width: 5,
                alignment: "center",
            },
            {
                value: "ตามจริง",
                rowSpan: 0,
                colSpan: 2,
                width: 5,
                alignment: "center",
            },
        ];
        return arr.map((item) => {
            return new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                rowSpan: item.rowSpan,
                columnSpan: item.colSpan,
                width: {
                    size: convertInchesToTwip(item.width),
                    type: WidthType.DXA,
                },
                children: [
                    new Paragraph({
                        alignment: "center",
                        children: [
                            new TextRun({
                                text: item.value,
                                bold: true,
                                size: font.size.tbHeader,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };

    const setHeadTbR3 = () => {
        const arr = [
            {
                value: "สัปดาห์",
                width: 5,
                alignment: "center",
                colSpan: 0,
            },
            {
                value: "รวม",
                width: 5,
                alignment: "center",
                colSpan: 0,
            },
            {
                value: "เริ่มงาน",
                width: 5,
                alignment: "center",
                colSpan: 0,
            },
            {
                value: "สิ้นสุด",
                width: 5,
                alignment: "center",
                colSpan: 0,
            },
            {
                value: "เริ่มงาน",
                width: 5,
                alignment: "center",
                colSpan: 0,
            },
            {
                value: "แล้วเสร็จ",
                width: 5,
                alignment: "center",
                colSpan: 0,
            },
        ];
        return arr.map((item) => {
            return new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                columnSpan: item.colSpan,
                width: {
                    size: convertInchesToTwip(item.width),
                    type: WidthType.DXA,
                },
                children: [
                    new Paragraph({
                        alignment: "center",
                        children: [
                            new TextRun({
                                text: item.value,
                                bold: true,
                                size: font.size.tbHeader,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };

    const tb6 = new Table({
        rows: [
            new TableRow({
                tableHeader: true,
                children: [...setHeadTbR1()],
            }),
            new TableRow({
                tableHeader: true,
                children: [...setHeadTbR2()],
            }),
            new TableRow({
                tableHeader: true,
                children: [...setHeadTbR3()],
            }),
        ],
    });

    dataReport.map((item, index) => {
        const arrC = [
            { width: 5, value: item.routeNo, alignment: "center" },
            { width: 5, value: item.areaOwner, alignment: "center" },
            { width: 5, value: item.areaLocation, alignment: "left" },
            { width: 5, value: item.areaSurface, alignment: "center" },
            { width: 5, value: item.planNo, alignment: "center" },
            { width: 5, value: item.asDesignPipeLength, alignment: "center" },
            { width: 5, value: item.resultLength, alignment: "center" },
            { width: 5, value: item.resultAccure, alignment: "center" },
            { width: 5, value: item.approveDate, alignment: "center" },
            { width: 5, value: item.duration, alignment: "center" },
            { width: 5, value: item.datePlanBegin, alignment: "center" },
            { width: 5, value: item.datePlanEnd, alignment: "center" },
            { width: 5, value: item.dateActualBegin, alignment: "center" },
            { width: 5, value: item.dateActualEnd, alignment: "center" },
            { width: 5, value: item.acceptDate, alignment: "center" },
        ];
        tb6.root.push(
            new TableRow({
                children: [
                    ...arrC.map((item, index) => {
                        return new TableCell({
                            width: {
                                size: convertInchesToTwip(item.width),
                                type: WidthType.DXA,
                            },
                            children: [
                                new Paragraph({
                                    alignment: item.alignment,
                                    children: [
                                        new TextRun({
                                            text: item.value,
                                            bold: true,
                                            size: font.size.tbbody,
                                            font: font.SarabunPSK,
                                        }),
                                    ],
                                }),
                            ],
                        });
                    }),
                ],
            })
        );
    });

    const setFooterTb = [
        {
            value: "ผลรวม",
            colSpan: 5,
        },
        {
            value: "",
            colSpan: 0,
        },
        {
            value: "",
            colSpan: 0,
        },
        {
            value: "",
            colSpan: 0,
        },
        {
            value: "",
            colSpan: 7,
        },
    ];

    tb6.root.push(
        new TableRow({
            children: [
                ...setFooterTb.map((item, index) => {
                    return new TableCell({
                        columnSpan: item.colSpan,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.value,
                                        bold: true,
                                        size: font.size.tbbody,
                                    }),
                                ],
                            }),
                        ],
                    });
                }),
            ],
        })
    );

    const setTb7 = () => {
        const arr = [
            {
                value: "หมายเหตุ",
                width: 2,
                alignment: "left",
            },
            {
                value: "1.ตรวจรับงานแล้ว ",
                width: 2,
                alignment: "left",
            },
            {
                value: "...................................",
                width: 2,
                alignment: "left",
            },
            {
                value: "เส้นทาง ระว่างดำเนินการ ",
                width: 4,
                alignment: "left",
            },
            {
                value: "...................................",
                width: 2,
                alignment: "left",
            },
            {
                value: "เส้นทาง",
                width: 1,
                alignment: "left",
            },
            {
                value: "คณะกรรมการ",
                width: 15,
                alignment: "center",
            },
            {
                value: "ประธานกรรมการ",
                width: 3,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: convertInchesToTwip(item.width),
                    type: WidthType.DXA,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const tb7 = new Table({
        rows: [
            new TableRow({
                children: [...setTb7()],
            }),
        ],
    });

    const setTb8 = () => {
        const arr = [
            {
                value: "",
                width: 5,
                alignment: "left",
            },
            {
                value: "2.เบิกเงินแล้ว ................................... งวด ",
                width: 20,
                alignment: "left",
            },

            {
                value: "เป็นเงิน ...................................  บาท ",
                width: 20,
                alignment: "left",
            },
            {
                value: "",
                width: 13,
                alignment: "center",
            },
            {
                value: "กรรมการ",
                width: 6,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const tb8 = new Table({
        rows: [
            new TableRow({
                children: [...setTb8()],
            }),
        ],
    });

    const setTb9 = () => {
        const arr = [
            {
                value: "",
                width: 0.8,
                alignment: "left",
            },
            {
                value: "3.งานล่าช้า ",
                width: 1,
                alignment: "left",
            },
            {
                value: "...................................",
                width: 1,
                alignment: "left",
            },
            {
                value: pdfImage.unchecked,
                width: 1,
                alignment: "right",
            },
            {
                value: " ปัญหากรรมสิทธิ์พื้นที่ก่อสร้าง",
                width: 51,
                alignment: "left",
            },
            {
                value: "กรรมการและเลขานุการ",
                width: 1,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            if (index === 3) {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new ImageRun({
                                    data: item.value,
                                    transformation: {
                                        width: 15,
                                        height: 15,
                                    },
                                }),
                            ],
                        }),
                    ],
                });
            } else {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                });
            }
        });
    };
    const tb9 = new Table({
        rows: [
            new TableRow({
                children: [...setTb9()],
            }),
        ],
    });

    const setTb10 = () => {
        const arr = [
            {
                value: "",
                width: 5,
                alignment: "left",
            },
            {
                value: pdfImage.unchecked,
                width: 1,
                alignment: "right",
            },
            {
                value: " อื่นๆ ...................................",
                width: 10,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            if (index === 1) {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new ImageRun({
                                    data: item.value,
                                    transformation: {
                                        width: 15,
                                        height: 15,
                                    },
                                }),
                            ],
                        }),
                    ],
                });
            } else {
                return new TableCell({
                    borders: cellBorder.noBorder,
                    width: {
                        size: convertInchesToTwip(item.width),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: item.alignment,
                            children: [
                                new TextRun({
                                    text: item.value,
                                    size: font.size.tbbody,
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                });
            }
        });
    };
    const tb10 = new Table({
        rows: [
            new TableRow({
                children: [...setTb10()],
            }),
        ],
    });

    const setTb11 = () => {
        const arr = [
            {
                value: "",
                width: 8,
                alignment: "left",
            },
            {
                value: "4. ขยายอายุสัญญา",
                width: 10,
                alignment: "left",
            },
            {
                value: " ............................................................... ",
                width: 20,
                alignment: "left",
            },
            {
                value: " ครั้ง ",
                width: 60,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const tb11 = new Table({
        rows: [
            new TableRow({
                children: [...setTb11()],
            }),
        ],
    });

    const setTb12 = () => {
        const arr = [
            {
                value: "",
                width: 8,
                alignment: "left",
            },
            {
                value: "5.เพิ่มวงเงินสัญญาอีก",
                width: 10,
                alignment: "left",
            },
            {
                value: " .................................................................................. ",
                width: 25,
                alignment: "left",
            },
            {
                value: " ครั้ง ",
                width: 60,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const tb12 = new Table({
        rows: [
            new TableRow({
                children: [...setTb12()],
            }),
        ],
    });

    const setTb13 = () => {
        const arr = [
            {
                value: "",
                width: 5.5,
                alignment: "left",
            },
            {
                value: "6.",
                width: 1,
                alignment: "left",
            },
            {
                value: " .................................................................................................................................................................... ",
                width: 59,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const tb13 = new Table({
        rows: [
            new TableRow({
                children: [...setTb13()],
            }),
        ],
    });

    const setTb14 = () => {
        const arr = [
            {
                value: "เรียน กรรมการและเลขานุการ เลขที่สัญญา ",
                width: 16,
                alignment: "left",
            },

            {
                value: setView("contractNo"),
                width: 60,
                alignment: "left",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                                underline: { type: index === 1 ? "dotted" : "" },
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const tb14 = new Table({
        rows: [
            new TableRow({
                children: [...setTb14()],
            }),
        ],
    });

    const setTb15 = () => {
        const arr = [
            {
                value: "เพื่อโปรดทราบ",
                width: 20,
                alignment: "center",
            },
            {
                value: "",
                width: 30,
                alignment: "center",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const tb15 = new Table({
        rows: [
            new TableRow({
                children: [...setTb15()],
            }),
        ],
    });

    const setTb16r1 = () => {
        const arr = [
            {
                value: "",
                width: 20,
                alignment: "center",
            },
            {
                value: "(.........................................)",
                width: 30,
                alignment: "center",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const setTb16r2 = () => {
        const arr = [
            {
                value: "",
                width: 20,
                alignment: "center",
            },
            {
                value: "ผู้ควบคุมงาน",
                width: 30,
                alignment: "center",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const setTb16r3 = () => {
        const arr = [
            {
                value: "",
                width: 20,
                alignment: "center",
            },
            {
                value: "ผู้จัดรายงาน",
                width: 30,
                alignment: "center",
            },
        ];

        return arr.map((item, index) => {
            return new TableCell({
                borders: cellBorder.noBorder,
                width: {
                    size: item.width,
                    type: WidthType.PERCENTAGE,
                },
                children: [
                    new Paragraph({
                        alignment: item.alignment,
                        children: [
                            new TextRun({
                                text: item.value,
                                size: font.size.tbbody,
                                font: font.SarabunPSK,
                            }),
                        ],
                    }),
                ],
            });
        });
    };
    const tb16 = new Table({
        rows: [
            new TableRow({
                children: [...setTb16r1()],
            }),
            new TableRow({
                children: [...setTb16r2()],
            }),
            new TableRow({
                children: [...setTb16r3()],
            }),
        ],
    });

    // Gen Docx
    const doc = new Document({
        sections: [
            {
                children: [space, p1, tb1, space, tb2, tb3, tb4, tb5, space, tb6, space, tb7, space, tb8, space, tb9, space, tb10, space, tb11, space, tb12, space, tb13, space, tb14, space, tb15, space, tb16],
                properties: {
                    page: {
                        margin: {
                            top: convertInchesToTwip(0.5),
                            right: convertInchesToTwip(0.5),
                            bottom: convertInchesToTwip(0.5),
                            left: convertInchesToTwip(0.5),
                        },

                        size: { orientation: PageOrientation.LANDSCAPE },
                    },
                    type: WidthType.DXA,
                },
            },
        ],
    });

    Packer.toBlob(doc).then((blob) => {
        setLoading(false);
        saveAs(blob, `${filename}.docx`);
    });
};
